import { Component } from 'react';
import I18n from 'I18n';
import TimezoneTypes from '../constants/TimezoneTypes';
// @ts-expect-error untyped JS module
import formatShortDate from '../utils/formatShortDate';
// @ts-expect-error untyped JS module
import formatMediumDate from '../utils/formatMediumDate';
// @ts-expect-error untyped JS module
import formatShortMY from '../utils/formatShortMonthYear';
// @ts-expect-error untyped JS module
import formatMediumMY from '../utils/formatMediumMonthYear';
// @ts-expect-error untyped JS module
import formatShortQY from '../utils/formatShortQuarterYear';
// @ts-expect-error untyped JS module
import formatShortFullDate from '../utils/formatShortFullDate';
// @ts-expect-error untyped JS module
import formatMediumFullDate from '../utils/formatMediumFullDate';
import { I18nHMRContext } from '../internal/i18n-internal';
import { jsx as _jsx } from "react/jsx-runtime";
const extraFormats = {
  'short-date': formatShortDate,
  'medium-date': formatMediumDate,
  'short-full-date': formatShortFullDate,
  'medium-full-date': formatMediumFullDate,
  'short-m-y': formatShortMY,
  'medium-m-y': formatMediumMY,
  'short-q-y': formatShortQY
};
export default class FormattedDateTime extends Component {
  render() {
    const {
      value,
      format,
      type
    } = this.props;
    // @ts-expect-error format is a dynamic key into extraFormats
    const specialFormatter = extraFormats[format];
    let date = '';
    if (specialFormatter) {
      date = specialFormatter(value, type);
    } else {
      // @ts-expect-error fix after function component migration
      date = I18n.moment[type](value).format(format);
    }
    return /*#__PURE__*/_jsx("span", {
      children: date
    });
  }
}
FormattedDateTime.displayName = 'FormattedDateTime';
FormattedDateTime.contextType = I18nHMRContext;
FormattedDateTime.defaultProps = {
  type: TimezoneTypes.PORTAL
};